import { fetchGracenoteLineups } from "core/API/GameMasterLineup";
import Cookies from "js-cookie";
import { getCurrentWorkplaceId } from 'core/session/workplaceStore';

export const fetchGracenoteDefaults = async () => {

    const workplaceId = getCurrentWorkplaceId();
    const lineupsData = await fetchGracenoteLineups(workplaceId);
}